import { ExportTemplateResponse } from '@pmp/api';
import { CrudActionType, CrudStateType } from './interfaces';

export const initialState: CrudStateType = {
  data: null,
  open: false,
  viewsModal: { open: false, loading: false, tableViews: [], selectedView: null },
  additionalFields: null,
  additionalFieldsArray: null,
};

export function reducer(prevState: CrudStateType, action: CrudActionType): CrudStateType {
  switch (action.type) {
    case 'open':
      return {
        ...prevState,
        open: true,
        data: action.data ?? null,
        additionalFields: action.additionalFields ?? null,
        additionalFieldsArray: action.additionalFieldsArray ?? null,
      };
    case 'setColumnOrder':
      return {
        ...prevState,
        data: {
          ...(prevState.data as ExportTemplateResponse),
          columnOrder: action.columnOrder ?? prevState.data?.columnOrder ?? [],
        },
      };
    case 'selectView':
      return {
        ...prevState,
        viewsModal: {
          ...prevState.viewsModal,
          selectedView: action.selectedView ?? null,
        },
      };
    case 'openViewsModal':
      return {
        ...prevState,
        viewsModal: {
          open: true,
          loading: true,
          tableViews: [],
          selectedView: null,
        },
      };
    case 'setTableViews':
      return {
        ...prevState,
        viewsModal: {
          ...prevState.viewsModal,
          loading: false,
          tableViews: action.tableViews ?? [],
        },
      };
    case 'closeViewsModal':
      return {
        ...prevState,
        viewsModal: {
          ...prevState.viewsModal,
          open: false,
        },
      };
    case 'close':
      return {
        ...prevState,
        open: false,
      };
    default:
      throw new Error('No action provided');
  }
}
